"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5684],{

/***/ 60822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DesignSystem_QuickViewModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(72651);
// EXTERNAL MODULE: ./src/components/VariantRadioGroup/index.js
var VariantRadioGroup = __webpack_require__(16873);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(38855);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(24762);
// EXTERNAL MODULE: ./src/components/ReactSlickCarousel/index.js
var ReactSlickCarousel = __webpack_require__(42783);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/components/ProductMediaRenderer/MediaContainer.tsx
var MediaContainer = __webpack_require__(48577);
;// CONCATENATED MODULE: ./src/components/DesignSystem/QuickViewModal/QuickViewImageComponent.js







var QuickViewCarouselMobile = function(props) {
    var imageArray = props.imageArray;
    var sliderRef = (0,react.useRef)();
    var ref = (0,react.useState)(0), activeSlide = ref[0], setActiveSlide = ref[1];
    var ref1 = (0,react.useState)(0), initialSlide = ref1[0], setInitialSlide = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        setInitialSlide(0);
        sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(0);
        stopVideo();
    }, [
        props.activeVariant
    ]);
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        activeSlide: initialSlide,
        afterChange: function(current) {
            return setActiveSlide(current);
        },
        beforeChange: function(current) {
            var ref;
            if (((ref = imageArray[current]) === null || ref === void 0 ? void 0 : ref.media_type) === constants/* MEDIA_TYPES.YOUTUBE_VIDEO */.w_.YOUTUBE_VIDEO) {
                stopVideo();
            }
        }
    };
    if (!imageArray || imageArray.length === 0) return null;
    var stopVideo = function() {
        var productVedioIframe = document.querySelector(".mobileQV-image-slider iframe");
        productVedioIframe && (productVedioIframe.src = productVedioIframe.src);
    };
    /**
   * slider prev button
   * click handler function
   */ var onPrevClick = function() {
        var ref;
        if (sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickPrev) {
            var ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickPrev();
        }
    };
    /**
   * slider next button
   * click handler function
   */ var onNextClick = function() {
        var ref;
        if (sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickNext) {
            var ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickNext();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactSlickCarousel/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: function(slider) {
            return sliderRef.current = slider;
        }
    }, settings), {
        children: imageArray === null || imageArray === void 0 ? void 0 : imageArray.map(function(image, index) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(MediaContainer/* MediaContainer */.X, {
                containerClasses: "tw-max-h-[480px] tw-max-w-[100%] tw-mx-auto",
                children: (image === null || image === void 0 ? void 0 : image.media_type) === constants/* MEDIA_TYPES.YOUTUBE_VIDEO */.w_.YOUTUBE_VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "flex justify-center items-center h-100 relative tw-w-full",
                    children: [
                        imageArray.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: " absolute left-0 h3 w2 bg-black-20 flex justify-center items-center",
                                    onClick: onPrevClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://cdn.dotpe.in/longtail/themes/8073865/1cy3Zqf6.webp",
                                        className: "img h1"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: " absolute right-0 h3 w2 bg-black-20 flex justify-center items-center",
                                    onClick: onNextClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://cdn.dotpe.in/longtail/themes/8073865/7cs2CGfO.webp",
                                        className: "img h1"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            src: "https://www.youtube.com/embed/".concat(image === null || image === void 0 ? void 0 : (ref = image.image_url) === null || ref === void 0 ? void 0 : ref.substr(-11), "?autoplay=").concat(activeSlide === index ? 1 : 0),
                            title: "YouTube video player",
                            frameBorder: "0",
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                            allowFullScreen: true,
                            auto: true,
                            className: "tw-h-full tw-w-full tw-object-contain"
                        })
                    ]
                }) : (image === null || image === void 0 ? void 0 : image.media_type) !== constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image.image_url,
                    alt: "image ".concat(image.image_id),
                    style: {
                        objectFit: "contain",
                        width: "100%",
                        height: "100%"
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    src: (image === null || image === void 0 ? void 0 : image.image_url) || "",
                    controls: true,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            }, index);
        })
    }));
};
var QuickViewDesktopImageComponent = function(props) {
    var imageArray = props.imageArray;
    var sliderRef = (0,react.useRef)();
    // const [activeSlide, setActiveSlide] = useState(0);
    var ref = (0,react.useState)(0), initialSlide = ref[0], setInitialSlide = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        setInitialSlide(0);
        sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(0);
    }, [
        props.activeVariant
    ]);
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        activeSlide: initialSlide,
        // afterChange: current => setActiveSlide(current),
        beforeChange: function(current) {
            var ref;
            if (((ref = imageArray[current]) === null || ref === void 0 ? void 0 : ref.media_type) === constants/* MEDIA_TYPES.YOUTUBE_VIDEO */.w_.YOUTUBE_VIDEO) {
                stopVideo();
            }
        }
    };
    var stopVideo = function() {
        var productVedioIframe = document.querySelector(".desktopQV-vedio > iframe");
        productVedioIframe && (productVedioIframe.src = productVedioIframe.src);
    };
    /**
   * slider prev button
   * click handler function
   */ var onPrevClick = function() {
        var ref;
        if (sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickPrev) {
            var ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickPrev();
        }
    };
    /**
   * slider next button
   * click handler function
   */ var onNextClick = function() {
        var ref;
        if (sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickNext) {
            var ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickNext();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactSlickCarousel/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: sliderRef
    }, settings), {
        children: imageArray === null || imageArray === void 0 ? void 0 : imageArray.map(function(image, index) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(MediaContainer/* MediaContainer */.X, {
                containerClasses: "tw-mx-auto tw-max-h-[480px] tw-max-w-full",
                children: (image === null || image === void 0 ? void 0 : image.media_type) === constants/* MEDIA_TYPES.YOUTUBE_VIDEO */.w_.YOUTUBE_VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "desktopQV-vedio flex justify-center items-center h-100 relative bg-black tw-h-full tw-w-full",
                    children: [
                        imageArray.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: " absolute left-0 h3 w2 bg-black-20 flex justify-center items-center",
                                    onClick: onPrevClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://cdn.dotpe.in/longtail/themes/8073865/1cy3Zqf6.webp",
                                        className: "img h1"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: " absolute right-0 h3 w2 bg-black-20 flex justify-center items-center",
                                    onClick: onNextClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://cdn.dotpe.in/longtail/themes/8073865/7cs2CGfO.webp",
                                        className: "img h1"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            className: "tw-h-full tw-w-full tw-object-contain",
                            src: "https://www.youtube.com/embed/".concat(image === null || image === void 0 ? void 0 : (ref = image.image_url) === null || ref === void 0 ? void 0 : ref.substr(-11)),
                            title: "YouTube video player",
                            frameBorder: "0",
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                            allowFullScreen: true,
                            auto: true
                        })
                    ]
                }) : (image === null || image === void 0 ? void 0 : image.media_type) !== constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image.image_url,
                    alt: "image ".concat(image.image_id),
                    style: {
                        objectFit: "contain",
                        width: "100%",
                        height: "100%"
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    src: (image === null || image === void 0 ? void 0 : image.image_url) || "",
                    controls: true,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            }, index);
        })
    }));
};


// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(66162);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(67936);
// EXTERNAL MODULE: ./src/assets/svgExports/MinusIcon.js
var MinusIcon = __webpack_require__(82513);
;// CONCATENATED MODULE: ./src/assets/svgExports/QVCloseIcon.js

function QVCloseIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 44,
        height: props.size || 44,
        viewBox: "0 0 44 44",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    children: ".prefix__c{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:3px}"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                transform: "translate(-131.085 -188.085)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "none",
                        d: "M131.085 188.085h44v44h-44z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: 21,
                        cy: 21,
                        r: 21,
                        transform: "translate(132.085 189.085)",
                        fill: "#282829"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "prefix__c",
                d: "M15 15l14 14M29 15L15 29"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/assets/svgExports/NoStoreInfoIcon.js
var NoStoreInfoIcon = __webpack_require__(19105);
// EXTERNAL MODULE: ./src/assets/svgExports/PlusIcon.js
var PlusIcon = __webpack_require__(8886);
// EXTERNAL MODULE: ./src/utils/isNotifyProductEnabled.js
var isNotifyProductEnabled = __webpack_require__(32953);
// EXTERNAL MODULE: ./src/utils/isDeliveryPincodeBased.js
var isDeliveryPincodeBased = __webpack_require__(84110);
// EXTERNAL MODULE: ./src/utils/storeGSTStatus.js
var storeGSTStatus = __webpack_require__(41359);
// EXTERNAL MODULE: ./src/utils/checkForLimitedQuantity.js
var checkForLimitedQuantity = __webpack_require__(27994);
// EXTERNAL MODULE: ./src/utils/getItemAmountForPDP.js
var getItemAmountForPDP = __webpack_require__(44990);
// EXTERNAL MODULE: ./src/components/Common/DetailedDescription/index.js
var DetailedDescription = __webpack_require__(59696);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/CartButton.styles.js
var CartButton_styles = __webpack_require__(51592);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/components/CheckItemDelivery/CheckItemDelivery.js + 1 modules
var CheckItemDelivery = __webpack_require__(25180);
// EXTERNAL MODULE: ./src/components/RatingBox/index.js
var RatingBox = __webpack_require__(18468);
// EXTERNAL MODULE: ./src/components/ReviewsSection/index.js + 7 modules
var ReviewsSection = __webpack_require__(53724);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(82516);
// EXTERNAL MODULE: ./src/components/NotifyProduct/index.js
var NotifyProduct = __webpack_require__(32890);
// EXTERNAL MODULE: ./src/utils/mutateItemObjectWithCartData.js
var mutateItemObjectWithCartData = __webpack_require__(22787);
// EXTERNAL MODULE: ./src/utils/mutateVariantItemWithCartData.js
var mutateVariantItemWithCartData = __webpack_require__(59186);
// EXTERNAL MODULE: ./src/utils/getDiscountPercentage.js
var getDiscountPercentage = __webpack_require__(53716);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/utils/getProductImagesForQVM.js
/**
 * Helper function which returns the sequenced
 * array with the help for variants for QuickViewModal (QVM)
 * @param {object} product
 * @param {number} selectedVariantId
 * @return {array}
 */ 
var getProductImagesForQVM = function(product, selectedVariantId) {
    var ref;
    var output = [];
    product = JSON.parse(JSON.stringify(product));
    if ((product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) && selectedVariantId > -1) {
        var selectedVariant = product === null || product === void 0 ? void 0 : product.variants.find(function(item) {
            return (item === null || item === void 0 ? void 0 : item.variant_id) === selectedVariantId;
        });
        var selectedVariantImg = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.images;
        if (product === null || product === void 0 ? void 0 : product.images) {
            output = selectedVariantImg ? (0,_to_consumable_array/* default */.Z)(selectedVariantImg).concat((0,_to_consumable_array/* default */.Z)(product.images)) : product === null || product === void 0 ? void 0 : product.images;
        } else output = selectedVariantImg;
    } else {
        output = product === null || product === void 0 ? void 0 : product.images;
    }
    if (output === null || Array.isArray(output) && !output.length) {
        output = [
            {
                image_url: product === null || product === void 0 ? void 0 : product.image_url,
                thumbnail_url: product === null || product === void 0 ? void 0 : product.thumbnail_url
            }
        ];
    }
    return output;
};

// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
;// CONCATENATED MODULE: ./src/utils/checkForInventoryExceeds.js
/**
 * Function to check if in case of managed inventory is allowed
 * whether current quantity exceeds available quantity
 * if managed inventory is false, allow without checks
 * @param {*} stockItem
 * @return {boolean} boolean
 */ var checkForInventoryExceeds = function(stockItem) {
    if (!(stockItem && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.managed_inventory) && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.available_quantity) && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.quantity))) {
        return true;
    }
    return stockItem.quantity < stockItem.available_quantity;
};

// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/containers/ProductDescription/Utils/common.js
var Utils_common = __webpack_require__(72911);
// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(91240);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/AllProductPagePromos/index.tsx + 1 modules
var AllProductPagePromos = __webpack_require__(42705);
// EXTERNAL MODULE: ./src/constants/promos.js
var promos = __webpack_require__(10445);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/SatisfiedBogoPromos/index.tsx + 1 modules
var SatisfiedBogoPromos = __webpack_require__(57333);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(13508);
// EXTERNAL MODULE: ./src/components/QuntityUnavailableAlert/index.tsx
var QuntityUnavailableAlert = __webpack_require__(27913);
// EXTERNAL MODULE: ./src/components/ProductScheduler/index.tsx + 3 modules
var ProductScheduler = __webpack_require__(31937);
// EXTERNAL MODULE: ./src/utils/itemIndexFromCart.js
var itemIndexFromCart = __webpack_require__(48670);
// EXTERNAL MODULE: ./src/hooks/useItemScheduler.ts + 2 modules
var useItemScheduler = __webpack_require__(10862);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(99375);
;// CONCATENATED MODULE: ./src/components/DesignSystem/QuickViewModal/index.js



















































var QuickViewModal = function() {
    var openProductPersonalizationPopUp = function openProductPersonalizationPopUp() {
        checkRenderEnv/* IS_CLIENT */.kc && localStorage.setItem("activeVariantId", state.selectedVariantId);
        handleSetProductData(pdpData === null || pdpData === void 0 ? void 0 : pdpData.product);
        handleSetProductCustomizationCount(pdpData === null || pdpData === void 0 ? void 0 : pdpData.product);
        onPersonalizeProductClick();
    };
    var handleCartAction = function handleCartAction(type) {
        var ref, ref1;
        if ((0,Utils_common/* checkProductPersonalizationExist */.wj)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_type_flag, pdpData === null || pdpData === void 0 ? void 0 : (ref1 = pdpData.product) === null || ref1 === void 0 ? void 0 : ref1.product_personalization)) {
            checkRenderEnv/* IS_CLIENT */.kc && localStorage.setItem("activeVariantId", state.selectedVariantId);
            type === "inc" ? handleIncreamentClick(type, pdpData === null || pdpData === void 0 ? void 0 : pdpData.product) : handleDecreamentClick(type, pdpData === null || pdpData === void 0 ? void 0 : pdpData.product);
        } else {
            handleCartUpdate(type);
        }
    };
    var getGstAdjustedStyle = function getGstAdjustedStyle() {
        if ((0,storeGSTStatus/* isStoreGstExcluded */.n)() || (0,storeGSTStatus/* isStoreGstIncluded */.u)()) return "mb0px";
        return "";
    };
    var renderOutOfStock = function renderOutOfStock() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
            label: "Out Of Stock",
            backgroundColor: "#C6C6C6",
            fontSize: "18",
            px: "12px",
            py: "12px",
            mt: "24px",
            width: "100%",
            roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.roundness
        });
    };
    var renderNotAcceptingOrderMessage = function renderNotAcceptingOrderMessage() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "We are not accepting online orders right now.",
                " ",
                !!storePhone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "For queries, call us at",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "tel:".concat(storePhone),
                            onClick: numberClickFunc,
                            children: storePhone
                        })
                    ]
                })
            ]
        });
    };
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer,
            reviewSettings: state.catalogReducer.reviewSettings,
            storeInfo: state.storeReducer.store,
            cartData: state.cartReducer,
            pdpData: state.catalogReducer.pdpData,
            scheduleInfo: state.commonReducer.scheduleInfo
        };
    }), userData = ref2.userData, reviewSettings = ref2.reviewSettings, storeInfo = ref2.storeInfo, cartData = ref2.cartData, pdpData = ref2.pdpData, scheduleInfo = ref2.scheduleInfo;
    var schedualerConstraints = pdpData === null || pdpData === void 0 ? void 0 : (ref = pdpData.product) === null || ref === void 0 ? void 0 : ref.item_schedule;
    var isB2bStore = (0,getStoreType/* getStoreType */.K)(storeInfo) === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B;
    var showDetailedDescription = pdpData === null || pdpData === void 0 ? void 0 : (ref1 = pdpData.product) === null || ref1 === void 0 ? void 0 : ref1.description_detail;
    var ref3 = (0,react.useState)({
        itemCartIdx: -1,
        discountPercent: 0,
        activeVariant: -1,
        cost: {
            discounted_price: 0,
            price: 0
        },
        addItemsPossible: true,
        selectedVariantId: -1
    }), state = ref3[0], setState = ref3[1];
    var ref4 = (0,react.useState)(false), verifedBuyer = ref4[0], setVerifiedBuyer = ref4[1];
    var ref5 = (0,useFeatureLocks/* useFeatureLocks */.r)(), crrFeatureStatus = ref5.crrFeatureStatus, notifyMeFeatureStatus = ref5.notifyMeFeatureStatus;
    var isCRRFeatureUnlocked = !(crrFeatureStatus === null || crrFeatureStatus === void 0 ? void 0 : crrFeatureStatus.isLocked);
    var isNotifyMeFeatureVisible = notifyMeFeatureStatus === null || notifyMeFeatureStatus === void 0 ? void 0 : notifyMeFeatureStatus.isVisible;
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var ref6 = (0,react.useState)(false), showSchedulerError = ref6[0], setShowSchedulerError = ref6[1];
    var ref7 = (0,useCartHandler/* useCartHandlers */.u)(), handleSetProductData = ref7.handleSetProductData, onPersonalizeProductClick = ref7.onPersonalizeProductClick, handleSetProductCustomizationCount = ref7.handleSetProductCustomizationCount, handleIncreamentClick = ref7.handleIncreamentClick, handleDecreamentClick = ref7.handleDecreamentClick;
    var ref8 = (0,useItemScheduler/* default */.Z)(), setScheduleData = ref8.setScheduleData, changeSchedulingInfoAndSetCart = ref8.changeSchedulingInfoAndSetCart, addScheduleInfoToCart = ref8.addScheduleInfoToCart;
    var itemIndexInCart = (0,itemIndexFromCart/* itemIndexFromCart */.R)(cartData, pdpData === null || pdpData === void 0 ? void 0 : pdpData.product);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : ref1.schedule_info) {
            var ref2, ref3;
            setScheduleData(cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[itemIndexInCart]) === null || ref3 === void 0 ? void 0 : ref3.schedule_info);
        } else {
            setScheduleData(null);
        }
    }, [
        cartData
    ]);
    (0,react.useEffect)(function() {
        if (pdpData === null || pdpData === void 0 ? void 0 : pdpData.visible) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
        } else {
            document.getElementsByTagName("body")[0].style.overflowY = "auto";
        }
        return function() {
            document.getElementsByTagName("body")[0].style.overflowY = "auto";
        };
    }, [
        pdpData
    ]);
    (0,react.useEffect)(function() {
        if (pdpData.visible) {
            var ref;
            setState(function(state) {
                var ref;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    cost: (0,getItemAmountForPDP/* getItemAmountForPDP */.w)(pdpData.product, (pdpData === null || pdpData === void 0 ? void 0 : (ref = pdpData.product) === null || ref === void 0 ? void 0 : ref.variants_count) > 0 ? 0 : -1)
                });
            });
            dispatch((0,catalog/* fetchCatalogItemById */.eP)({
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                item_id: pdpData === null || pdpData === void 0 ? void 0 : (ref = pdpData.product) === null || ref === void 0 ? void 0 : ref.id,
                src: "quick_view_modal"
            }));
            if (userData === null || userData === void 0 ? void 0 : userData.isLogin) {
                var ref1, ref2;
                var data = {
                    phone: (userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone) || "",
                    item_id: pdpData === null || pdpData === void 0 ? void 0 : (ref2 = pdpData.product) === null || ref2 === void 0 ? void 0 : ref2.id,
                    store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id
                };
                if (data.phone === "") {
                    var ref3;
                    data.user_id = (userData === null || userData === void 0 ? void 0 : (ref3 = userData.data) === null || ref3 === void 0 ? void 0 : ref3.user_id) || "";
                }
                dispatch((0,catalog/* verifyBuyerForItem */.KB)(data, function(data) {
                    return setVerifiedBuyer(data);
                }));
            }
            if (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id) {
                dispatch((0,catalog/* getCustomerReviewSettings */.vV)(storeInfo.store_id));
            }
        } else {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    activeVariant: -1,
                    cost: {
                        discounted_price: 0,
                        price: 0
                    }
                });
            });
        }
    }, [
        pdpData.visible
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        var itemCartIdx = cartData.items.findIndex(function(el) {
            var ref;
            return (el.id || el.item_id) === (pdpData === null || pdpData === void 0 ? void 0 : (ref = pdpData.product) === null || ref === void 0 ? void 0 : ref.id);
        });
        var discountPercent = (0,getDiscountPercentage/* getDiscountPercentage */.$)(state === null || state === void 0 ? void 0 : (ref = state.cost) === null || ref === void 0 ? void 0 : ref.price, state === null || state === void 0 ? void 0 : (ref1 = state.cost) === null || ref1 === void 0 ? void 0 : ref1.discounted_price);
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                itemCartIdx: itemCartIdx,
                discountPercent: discountPercent
            });
        });
    }, [
        pdpData,
        cartData
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (pdpData === null || pdpData === void 0 ? void 0 : (ref = pdpData.product) === null || ref === void 0 ? void 0 : ref.variants) {
            var ref2, ref3, ref4;
            /** find the first active variant index */ var activeVariantIndex = -1;
            if (pdpData === null || pdpData === void 0 ? void 0 : (ref2 = pdpData.product) === null || ref2 === void 0 ? void 0 : ref2.variants) activeVariantIndex = pdpData === null || pdpData === void 0 ? void 0 : (ref3 = pdpData.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.variants) === null || ref4 === void 0 ? void 0 : ref4.findIndex(function(el) {
                return el.available === 1 && el.status !== 2;
            });
            setState(function(state) {
                var ref, ref1, ref2;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    activeVariant: activeVariantIndex,
                    selectedVariantId: activeVariantIndex > -1 ? pdpData === null || pdpData === void 0 ? void 0 : (ref = pdpData.product) === null || ref === void 0 ? void 0 : (ref1 = ref.variants) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[activeVariantIndex]) === null || ref2 === void 0 ? void 0 : ref2.variant_id : -1
                });
            });
        }
        if (pdpData === null || pdpData === void 0 ? void 0 : (ref1 = pdpData.product) === null || ref1 === void 0 ? void 0 : ref1.product_personalization) {
            handleSetProductCustomizationCount(pdpData === null || pdpData === void 0 ? void 0 : pdpData.product);
            handleSetProductData(pdpData === null || pdpData === void 0 ? void 0 : pdpData.product);
        }
    }, [
        pdpData.product
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (state.activeVariant > -1 && (pdpData === null || pdpData === void 0 ? void 0 : (ref = pdpData.product) === null || ref === void 0 ? void 0 : ref.variants)) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    cost: (0,getItemAmountForPDP/* getItemAmountForPDP */.w)(pdpData.product, state.activeVariant)
                });
            });
        }
    }, [
        state.activeVariant
    ]);
    // call following useEffect on every cartData change
    (0,react.useEffect)(function() {
        if (state.itemCartIdx !== -1) {
            // on cartData state change, allow addition of quantity possible
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    addItemsPossible: true
                });
            });
            if (state.selectedVariantId !== -1) {
                // if variant item
                var variantForStock = selectedVariantFromVariantItem();
                if (variantForStock && Object.keys(variantForStock).length) {
                    // if variant data exits
                    setState(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            addItemsPossible: checkForInventoryExceeds(variantForStock)
                        });
                    });
                }
            } else {
                var ref;
                // if non variant item
                var itemForStock = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref[state.itemCartIdx];
                if (itemForStock) {
                    setState(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            addItemsPossible: checkForInventoryExceeds(itemForStock)
                        });
                    });
                }
            }
        }
    }, [
        cartData
    ]);
    var numberClickFunc = function(e) {
        if (!(deviceWidth/* OSName */.F && (deviceWidth/* OSName */.F === "Android" || deviceWidth/* OSName */.F === "iPhone") && deviceWidth/* deviceWidth */.o < 766)) {
            e.preventDefault();
        }
    };
    var onClose = function() {
        dispatch((0,catalog/* savePDPData */.zP)({
            visible: false,
            product: {}
        }));
    };
    var handleCartUpdate = function(type) {
        var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var ref, ref1, ref2;
        /** Check if variant present in this item */ if ((pdpData === null || pdpData === void 0 ? void 0 : (ref = pdpData.product) === null || ref === void 0 ? void 0 : ref.variants_count) > 0) {
            dispatch((0,common/* saveProductLoaderId */.XG)(pdpData === null || pdpData === void 0 ? void 0 : pdpData.product.id));
            dispatch((0,common/* saveDetailedItemById */.VY)(pdpData === null || pdpData === void 0 ? void 0 : pdpData.product));
            /** If variant not pre selected */ if (state.activeVariant === -1) {
                onClose();
                switch(type){
                    case "add":
                        dispatch((0,common/* setVariantModalVisibility */.VZ)(true));
                        break;
                    case "inc":
                        dispatch((0,common/* setChooseAndRepeatModalVisibility */.uT)(true));
                        break;
                    case "dec":
                        dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(true));
                        break;
                }
            } else {
                var ref3, ref4;
                /** If variants are preselected */ var newCart = [];
                type = type === "add" || type === "inc" ? "inc" : type;
                newCart = (0,mutateVariantItemWithCartData/* mutateVariantItemWithCartData */.I)(type, pdpData === null || pdpData === void 0 ? void 0 : pdpData.product, pdpData === null || pdpData === void 0 ? void 0 : (ref3 = pdpData.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.variants) === null || ref4 === void 0 ? void 0 : ref4[state.activeVariant], cartData, null, null, null, count);
                addScheduleInfoToCart(newCart, pdpData === null || pdpData === void 0 ? void 0 : pdpData.product, scheduleInfo);
                dispatch((0,cart/* saveCart */.FP)(newCart));
            }
        } else {
            var newState = (0,mutateItemObjectWithCartData/* mutateItemObjectWithCartData */.L)(type, pdpData.product, cartData, null, null, null, count);
            addScheduleInfoToCart(newState, pdpData === null || pdpData === void 0 ? void 0 : pdpData.product, scheduleInfo);
            dispatch((0,cart/* saveCart */.FP)(newState));
        }
        dispatch((0,logs/* pushEventsLog */.U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain,
                page: window.location.href,
                device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref2 = userData.data) === null || ref2 === void 0 ? void 0 : ref2.phone
            }
        }));
    };
    var onBuyNowClickQuickView = function() {
        var ref;
        if (schedualerConstraints && !scheduleInfo) {
            setShowSchedulerError(true);
            return;
        }
        if (itemIndexInCart === -1) {
            handleCartUpdate("add");
        }
        router.push((0,routes.getRoute)(routes.PATH.CART, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var selectedVariantFromVariantItem = function() {
        var ref, ref1;
        return cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : ref1.variants_selected.find(function(variant) {
            return variant.variant_id === state.selectedVariantId;
        });
    };
    var returnItemQuantity = function() {
        if (itemIndexInCart >= 0) {
            var ref, ref1, ref2;
            if (cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.length) {
                var selectedVariant = selectedVariantFromVariantItem();
                var ref3;
                return (ref3 = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.quantity) !== null && ref3 !== void 0 ? ref3 : 0;
            } else {
                var ref4, ref5;
                return cartData === null || cartData === void 0 ? void 0 : (ref4 = cartData.items) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[itemIndexInCart]) === null || ref5 === void 0 ? void 0 : ref5.quantity;
            }
        }
        return 0;
    };
    var onVariantSelect = function(selectedInd, item) {
        setState(function(state) {
            var ref, ref1, ref2;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                activeVariant: selectedInd,
                selectedVariantId: pdpData === null || pdpData === void 0 ? void 0 : (ref = pdpData.product) === null || ref === void 0 ? void 0 : (ref1 = ref.variants) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[selectedInd]) === null || ref2 === void 0 ? void 0 : ref2.variant_id
            });
        });
    };
    var renderMobileView = function(children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            visible: pdpData === null || pdpData === void 0 ? void 0 : pdpData.visible,
            className: "bottom-modal zIndex99",
            animation: "slideUp",
            onClose: onClose,
            height: "auto",
            customStyles: {
                padding: 0
            },
            customMaskStyles: {
                background: "rgba(0, 0, 0, 0.9)"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "QuickViewModalContainer__close",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QVCloseIcon, {
                        size: 38
                    })
                }),
                children
            ]
        });
    };
    var renderDesktopView = function(children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
            className: "QuickViewModalContainer",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "QuickViewModalContainer__close",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QVCloseIcon, {
                        size: 30
                    })
                }),
                children
            ]
        });
    };
    var LeftCartButton = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton_styles/* InteractionComponent */.$1, {
            position: "left:14px;",
            width: "25px",
            onClick: function(e) {
                e.stopPropagation();
                handleCartAction("dec");
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MinusIcon/* MinusIcon */.V, {})
        });
    };
    var RightCartButton = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton_styles/* InteractionComponent */.$1, {
            position: "right:14px;",
            width: "25px",
            onClick: function(e) {
                if (state.addItemsPossible) {
                    e.stopPropagation();
                    handleCartAction("inc");
                } else {
                    (0,Toast/* toastNotifyInfo */.lU)("No more units available for purchase");
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: state.addItemsPossible ? "o-100" : "o-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon/* PlusIcon */.p, {})
            })
        });
    };
    var renderProductPersonalizationCTA = function() {
        var ref, ref1, ref2, ref3, ref4;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "!tw-mx-0 tw-w-full md:tw-w-[78%] md:tw-max-w-[550px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "tw-mx-auto tw-my-0 tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-[4px] tw-border-[0px] tw-bg-black tw-py-[0.625rem] tw-text-[0.875rem] tw-font-medium tw-text-[#fff] tw-outline-0",
                onClick: function() {
                    if (schedualerConstraints && !scheduleInfo) {
                        setShowSchedulerError(true);
                        return;
                    }
                    openProductPersonalizationPopUp();
                },
                style: {
                    backgroundColor: "".concat((storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.theme) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color : "#EA5151"),
                    borderRadius: "".concat((storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.theme) ? "".concat((0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : ref2.roundness)) : "8px"),
                    opacity: "1"
                },
                children: [
                    (storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.cta_config) === null || ref4 === void 0 ? void 0 : ref4.pdp_personalized_cta) || "Personalise and buy",
                    " "
                ]
            })
        });
    };
    var onChange = function() {
        var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "add", count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var ref, ref1;
        if ((0,Utils_common/* checkProductPersonalizationExist */.wj)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_type_flag, pdpData === null || pdpData === void 0 ? void 0 : (ref1 = pdpData.product) === null || ref1 === void 0 ? void 0 : ref1.product_personalization)) {
            openProductPersonalizationPopUp();
        } else {
            handleCartUpdate(type, count);
        }
    };
    var handleItemChange = function(type) {
        var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, reset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        var ref, ref1;
        if (schedualerConstraints && !scheduleInfo) {
            setShowSchedulerError(true);
            return;
        }
        var selectedProductInfo = state.activeVariant !== -1 ? pdpData === null || pdpData === void 0 ? void 0 : (ref = pdpData.product) === null || ref === void 0 ? void 0 : (ref1 = ref.variants) === null || ref1 === void 0 ? void 0 : ref1[state.activeVariant] : pdpData === null || pdpData === void 0 ? void 0 : pdpData.product;
        if (count && (selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.managed_inventory) && (selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.available_quantity) < count) {
            dispatch((0,common/* setUnavailableQuantityAlertState */.K6)({
                show: true,
                availableQuantity: selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.available_quantity,
                onConfirm: function() {
                    return onChange(type, selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.available_quantity);
                },
                onCancel: reset
            }));
        } else {
            onChange(type, count);
        }
    };
    var _renderAddToCartBuyAgainCta = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_flag) === 0) {
            return null;
        }
        if ((0,Utils_common/* checkProductPersonalizationExist */.wj)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.store_type_flag, pdpData === null || pdpData === void 0 ? void 0 : (ref2 = pdpData.product) === null || ref2 === void 0 ? void 0 : ref2.product_personalization) && itemIndexInCart === -1) {
            return renderProductPersonalizationCTA();
        }
        return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.services) === null || ref3 === void 0 ? void 0 : ref3.store_flag) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "QuickViewModal__bottom--btn-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* CartButton */.WE, {
                        allowCustomInput: !(pdpData === null || pdpData === void 0 ? void 0 : (ref4 = pdpData.product) === null || ref4 === void 0 ? void 0 : ref4.product_personalization),
                        leftButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftCartButton, {}),
                        rightButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightCartButton, {}),
                        label: (0,Utils_common/* checkProductPersonalizationExist */.wj)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.services) === null || ref5 === void 0 ? void 0 : ref5.store_type_flag, pdpData === null || pdpData === void 0 ? void 0 : (ref6 = pdpData.product) === null || ref6 === void 0 ? void 0 : ref6.product_personalization) ? (storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.cta_config) === null || ref8 === void 0 ? void 0 : ref8.pdp_personalized_cta) || "Personalise and buy" : "Add to cart",
                        primaryColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref9 = storeInfo.theme) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.colors) === null || ref10 === void 0 ? void 0 : ref10.primary_color,
                        roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref11 = storeInfo.theme) === null || ref11 === void 0 ? void 0 : ref11.roundness,
                        onChange: handleItemChange,
                        fontWeight: "400",
                        fontSize: "14",
                        py: "10px",
                        centered: true,
                        quantity: returnItemQuantity(),
                        style: {
                            width: 180,
                            justifyContent: "center"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "QuickViewModal__bottom--btn-container",
                    children: state.itemCartIdx === -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                        display: "inline-block",
                        label: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref12 = storeInfo.theme) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.cta_config) === null || ref13 === void 0 ? void 0 : ref13.pdp_cta) || "Buy Now",
                        backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref14 = storeInfo.theme) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.colors) === null || ref15 === void 0 ? void 0 : ref15.primary_color,
                        roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref16 = storeInfo.theme) === null || ref16 === void 0 ? void 0 : ref16.roundness,
                        fontWeight: "400",
                        py: "10px",
                        onClick: onBuyNowClickQuickView,
                        style: {
                            width: 180
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "go-to-cart__btn",
                        style: {
                            borderRadius: "".concat((0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref17 = storeInfo.theme) === null || ref17 === void 0 ? void 0 : ref17.roundness))
                        },
                        onClick: function() {
                            onClose();
                            setTimeout(function() {
                                return router.push((0,routes.getRoute)(routes.PATH.CART, storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.domain));
                            });
                        },
                        children: "Go to Cart"
                    })
                })
            ]
        });
    };
    var _renderImagesBox = function() {
        var imagesArray = getProductImagesForQVM(pdpData === null || pdpData === void 0 ? void 0 : pdpData.product, state.selectedVariantId);
        return deviceWidth/* deviceWidth */.o < 767 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickViewCarouselMobile, {
            imageArray: imagesArray,
            activeVariant: state.activeVariant
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickViewDesktopImageComponent, {
            imageArray: imagesArray,
            activeVariant: state.activeVariant
        });
    };
    var shouldReviewItem = function() {
        if (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.verified_buyer) return verifedBuyer;
        return true;
    };
    var scrollToReviewsSection = function() {
        if (!shouldReviewItem()) return;
        document.getElementById("reviews-section").scrollIntoView();
    };
    var _renderDetailedDescription = function(className) {
        var ref;
        return showDetailedDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailedDescription/* default */.Z, {
            className: className,
            detailedDescription: pdpData === null || pdpData === void 0 ? void 0 : (ref = pdpData.product) === null || ref === void 0 ? void 0 : ref.description_detail
        }) : null;
    };
    var _renderContent = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "QuickViewModal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "QuickViewModal__main",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "QuickViewModal__main--image-component",
                            children: [
                                _renderImagesBox(),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    className: "flex-ns justify-center items-center pv4",
                                    children: (pdpData === null || pdpData === void 0 ? void 0 : (ref = pdpData.product) === null || ref === void 0 ? void 0 : ref.available) === 0 || state.activeVariant !== -1 && (pdpData === null || pdpData === void 0 ? void 0 : (ref1 = pdpData.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[state.activeVariant]) === null || ref3 === void 0 ? void 0 : ref3.available) === 0 ? isNotifyMeFeatureVisible && (0,isNotifyProductEnabled/* isNotifyProductEnabled */.Z)() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyProduct/* default */.Z, {
                                        product: pdpData === null || pdpData === void 0 ? void 0 : pdpData.product,
                                        activeVariant: {
                                            variant_id: state.selectedVariantId !== -1 ? state.selectedVariantId : null
                                        }
                                    }) : renderOutOfStock() : deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? null : _renderAddToCartBuyAgainCta()
                                }),
                                checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)(SatisfiedBogoPromos/* default */.Z, {
                                    type: promos/* PROMO_APPLICABILITY_TYPES.PRODUCT */.d.PRODUCT,
                                    productId: pdpData === null || pdpData === void 0 ? void 0 : (ref4 = pdpData.product) === null || ref4 === void 0 ? void 0 : ref4.id,
                                    showBottomCTA: true,
                                    customClasses: "tw-max-w-[450px] tw-mx-auto !tw-pt-0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "QuickViewModal__main--inner relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "reactMagnifyImageId",
                                    className: "w-100 absolute",
                                    style: {
                                        top: 0,
                                        left: 0,
                                        height: "fit-content"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "QuickViewModal__main--info-box",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: pdpData === null || pdpData === void 0 ? void 0 : (ref5 = pdpData.product) === null || ref5 === void 0 ? void 0 : ref5.name
                                                }),
                                                (pdpData === null || pdpData === void 0 ? void 0 : (ref6 = pdpData.product) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.store_item_review_rating) === null || ref7 === void 0 ? void 0 : ref7.review_rating) && (pdpData === null || pdpData === void 0 ? void 0 : (ref8 = pdpData.product) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.store_item_review_rating) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.review_rating) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.avg_rating) && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center pt10px",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingBox/* default */.Z, {
                                                            isVisible: !!(pdpData === null || pdpData === void 0 ? void 0 : (ref12 = pdpData.product) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.store_item_review_rating) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.review_rating) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : ref15.avg_rating),
                                                            rating: pdpData === null || pdpData === void 0 ? void 0 : (ref16 = pdpData.product) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.store_item_review_rating) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.review_rating) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : ref19.avg_rating
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "mv0 f12px fw5 sonic-silver pl8px",
                                                            children: [
                                                                pdpData === null || pdpData === void 0 ? void 0 : (ref20 = pdpData.product) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.store_item_review_rating) === null || ref21 === void 0 ? void 0 : ref21.ratings_count,
                                                                " Ratings & ",
                                                                pdpData === null || pdpData === void 0 ? void 0 : (ref22 = pdpData.product) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.store_item_review_rating) === null || ref23 === void 0 ? void 0 : ref23.reviews_count,
                                                                " ",
                                                                "Reviews"
                                                            ]
                                                        })
                                                    ]
                                                }) : null,
                                                deviceWidth/* deviceWidth */.o > 766 && (userData === null || userData === void 0 ? void 0 : userData.isLogin) && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center pt8px pointer",
                                                            onClick: scrollToReviewsSection,
                                                            style: {
                                                                opacity: shouldReviewItem() ? 1 : 0.21
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    "data-tip": true,
                                                                    "data-for": "review-this-product",
                                                                    className: "fw6 f14px pr8px mv0",
                                                                    children: "Review this product"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/assets/images/right-arrow.svg",
                                                                    width: "16px",
                                                                    height: "8px"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                                            id: "review-this-product",
                                                            place: "bottom",
                                                            effect: "solid",
                                                            multiline: true,
                                                            padding: "8px",
                                                            disable: shouldReviewItem(),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "mv0 fw5 f12px",
                                                                children: [
                                                                    "Only buyers of this item can submit reviews. If you have any",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                    "concerns, please share them with us and we would look into it."
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "QuickViewModal__main--price-box ".concat(getGstAdjustedStyle()),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "price-amount--box",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "main-price",
                                                            style: {
                                                                color: storeInfo === null || storeInfo === void 0 ? void 0 : (ref24 = storeInfo.theme) === null || ref24 === void 0 ? void 0 : ref24.colors.primary_color
                                                            },
                                                            children: [
                                                                "₹",
                                                                state === null || state === void 0 ? void 0 : (ref25 = state.cost) === null || ref25 === void 0 ? void 0 : ref25.discounted_price
                                                            ]
                                                        }),
                                                        (state === null || state === void 0 ? void 0 : (ref26 = state.cost) === null || ref26 === void 0 ? void 0 : ref26.discounted_price) !== (state === null || state === void 0 ? void 0 : (ref27 = state.cost) === null || ref27 === void 0 ? void 0 : ref27.price) && (state === null || state === void 0 ? void 0 : (ref28 = state.cost) === null || ref28 === void 0 ? void 0 : ref28.discounted_price) !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "slashed-price",
                                                            children: [
                                                                "₹",
                                                                state === null || state === void 0 ? void 0 : (ref29 = state.cost) === null || ref29 === void 0 ? void 0 : ref29.price
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                (0,getDiscountPercentage/* getDiscountPercentage */.$)(state === null || state === void 0 ? void 0 : (ref30 = state.cost) === null || ref30 === void 0 ? void 0 : ref30.price, state === null || state === void 0 ? void 0 : (ref31 = state.cost) === null || ref31 === void 0 ? void 0 : ref31.discounted_price) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "price-amount--box",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "discounted-percent",
                                                        children: [
                                                            (0,getDiscountPercentage/* getDiscountPercentage */.$)(state === null || state === void 0 ? void 0 : (ref32 = state.cost) === null || ref32 === void 0 ? void 0 : ref32.price, state === null || state === void 0 ? void 0 : (ref33 = state.cost) === null || ref33 === void 0 ? void 0 : ref33.discounted_price),
                                                            "% OFF"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        (0,storeGSTStatus/* isStoreGstIncluded */.u)() && /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                            className: "QuickViewModal__main--gst-inclusive",
                                            children: "Inclusive of all taxes"
                                        }),
                                        (0,storeGSTStatus/* isStoreGstExcluded */.n)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                            className: "QuickViewModal__main--gst-exclusive",
                                            children: [
                                                "+",
                                                pdpData === null || pdpData === void 0 ? void 0 : (ref34 = pdpData.product) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.tax) === null || ref35 === void 0 ? void 0 : ref35.gst,
                                                "% GST Charges"
                                            ]
                                        }),
                                        !isB2bStore && !(pdpData === null || pdpData === void 0 ? void 0 : (ref36 = pdpData.product) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.variants) === null || ref37 === void 0 ? void 0 : ref37.length) && (0,checkForLimitedQuantity/* checkForLimitedQuantity */.U)(pdpData === null || pdpData === void 0 ? void 0 : pdpData.product) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "highlighter-red-color mt0 mb2 f12px",
                                            children: (pdpData === null || pdpData === void 0 ? void 0 : (ref38 = pdpData.product) === null || ref38 === void 0 ? void 0 : ref38.available_quantity) ? "Hurry! Only ".concat(pdpData === null || pdpData === void 0 ? void 0 : (ref39 = pdpData.product) === null || ref39 === void 0 ? void 0 : ref39.available_quantity, " units left!") : "Out of stock"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductScheduler/* default */.Z, {
                                            schedualerConstraints: schedualerConstraints,
                                            showSchedulerError: showSchedulerError,
                                            setScheduleInfo: function(data) {
                                                setShowSchedulerError(false);
                                                setScheduleData(data);
                                                changeSchedulingInfoAndSetCart(data, itemIndexInCart);
                                            },
                                            scheduleInfo: scheduleInfo,
                                            customClasses: "!tw-pt-[16px] md:!tw-pt-0 !tw-px-[18px] md:!tw-px-0 md:!tw-max-w-[380px]"
                                        }),
                                        (storeInfo === null || storeInfo === void 0 ? void 0 : (ref40 = storeInfo.services) === null || ref40 === void 0 ? void 0 : ref40.store_flag) !== 0 && !!(pdpData === null || pdpData === void 0 ? void 0 : (ref41 = pdpData.product) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.variants) === null || ref42 === void 0 ? void 0 : ref42.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "productDescription__contentBox--variant md:tw-pl-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    children: "Choose One"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantRadioGroup/* default */.Z, {
                                                    itemLowQty: pdpData === null || pdpData === void 0 ? void 0 : (ref43 = pdpData.product) === null || ref43 === void 0 ? void 0 : ref43.low_quantity,
                                                    itemList: (pdpData === null || pdpData === void 0 ? void 0 : (ref44 = pdpData.product) === null || ref44 === void 0 ? void 0 : ref44.variants) || [],
                                                    activeIdx: state.activeVariant,
                                                    onChange: onVariantSelect
                                                })
                                            ]
                                        }),
                                        !!(pdpData === null || pdpData === void 0 ? void 0 : (ref45 = pdpData.product) === null || ref45 === void 0 ? void 0 : ref45.description) && !!(storeInfo === null || storeInfo === void 0 ? void 0 : (ref46 = storeInfo.services) === null || ref46 === void 0 ? void 0 : ref46.store_flag) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "QuickViewModal__main--description-box",
                                            children: [
                                                (pdpData === null || pdpData === void 0 ? void 0 : (ref47 = pdpData.product) === null || ref47 === void 0 ? void 0 : ref47.description) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "fw6 f6 mb3",
                                                            children: "Details"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: pdpData === null || pdpData === void 0 ? void 0 : (ref48 = pdpData.product) === null || ref48 === void 0 ? void 0 : ref48.description
                                                            }
                                                        })
                                                    ]
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "QuickViewModal__bottom bottom--desktop",
                                                    children: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref49 = storeInfo.services) === null || ref49 === void 0 ? void 0 : ref49.store_flag) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                        className: "QuickViewModal--store-closed",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "QuickViewModal--store-closed-icon",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoStoreInfoIcon/* NoStoreInfoIcon */.T, {})
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "QuickViewModal--store-closed-para",
                                                                children: renderNotAcceptingOrderMessage()
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        _renderDetailedDescription("quick-view-mobile-html-description"),
                                        (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked && deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection/* default */.Z, {
                                            shouldReviewItem: shouldReviewItem,
                                            product: pdpData === null || pdpData === void 0 ? void 0 : pdpData.product
                                        }) : null
                                    ]
                                }),
                                (0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckItemDelivery/* default */.Z, {
                                    mb: "4.5vh",
                                    pb: 20,
                                    item_name: pdpData === null || pdpData === void 0 ? void 0 : (ref50 = pdpData.product) === null || ref50 === void 0 ? void 0 : ref50.name,
                                    item_id: pdpData === null || pdpData === void 0 ? void 0 : (ref51 = pdpData.product) === null || ref51 === void 0 ? void 0 : ref51.id,
                                    itemsPrice: state === null || state === void 0 ? void 0 : (ref52 = state.cost) === null || ref52 === void 0 ? void 0 : ref52.discounted_price
                                }) : null,
                                !checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)(SatisfiedBogoPromos/* default */.Z, {
                                    type: promos/* PROMO_APPLICABILITY_TYPES.PRODUCT */.d.PRODUCT,
                                    productId: pdpData === null || pdpData === void 0 ? void 0 : (ref53 = pdpData.product) === null || ref53 === void 0 ? void 0 : ref53.id,
                                    showBottomCTA: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllProductPagePromos/* default */.Z, {
                                    type: promos/* PROMO_APPLICABILITY_TYPES.PRODUCT */.d.PRODUCT,
                                    productId: pdpData === null || pdpData === void 0 ? void 0 : (ref54 = pdpData.product) === null || ref54 === void 0 ? void 0 : ref54.id,
                                    customClasses: "tw-pr-[40px]"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "QuickViewModal__bottom",
                    children: [
                        (storeInfo === null || storeInfo === void 0 ? void 0 : (ref55 = storeInfo.services) === null || ref55 === void 0 ? void 0 : ref55.store_flag) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "QuickViewModal--store-closed",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "QuickViewModal--store-closed-icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoStoreInfoIcon/* NoStoreInfoIcon */.T, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "QuickViewModal--store-closed-para",
                                    children: renderNotAcceptingOrderMessage()
                                })
                            ]
                        }),
                        (pdpData === null || pdpData === void 0 ? void 0 : (ref56 = pdpData.product) === null || ref56 === void 0 ? void 0 : ref56.available) && state.activeVariant === -1 || state.activeVariant !== -1 && ((ref58 = pdpData === null || pdpData === void 0 ? void 0 : (ref57 = pdpData.product) === null || ref57 === void 0 ? void 0 : ref57.variants[state.activeVariant]) === null || ref58 === void 0 ? void 0 : ref58.available) ? _renderAddToCartBuyAgainCta() : null
                    ]
                }),
                _renderDetailedDescription("quick-view-desktop-html-description"),
                (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked && deviceWidth/* deviceWidth */.o > constants/* MAX_MOBILE_WIDTH */.Cf ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection/* default */.Z, {
                    shouldReviewItem: shouldReviewItem,
                    product: pdpData === null || pdpData === void 0 ? void 0 : pdpData.product
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuntityUnavailableAlert/* default */.Z, {})
            ]
        });
    };
    return pdpData && (pdpData === null || pdpData === void 0 ? void 0 : pdpData.visible) ? deviceWidth/* deviceWidth */.o < 767 ? renderMobileView(_renderContent()) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "backdrop-container",
        children: renderDesktopView(_renderContent())
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var DesignSystem_QuickViewModal = (QuickViewModal);


/***/ })

}]);